import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../providers/AuthProvider";

export default function ProtectedRoute() {
  const { isAuthenticated, status } = useAuth();

  if (status === "booting") return null;

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
